import React from 'react';
import Navigation from './components/navigation'
import Home from './components/home'
import QuienesSomos from './components/quienessomos'
import Acerca from './components/acerca'
import Portfolio from './components/portfolio'
import OurTeam from './components/ourteam'
import Contacto from './components/contact'
import Footer from './components/footer'  

function App() {
  return (
    <div className="App">
      <Navigation/>
      <Home/>
      <QuienesSomos/>
      <Acerca/>
      <Portfolio/>
      <OurTeam/>
      <Contacto/>
      <Footer/>
    </div>
  );
}

export default App;
